"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAvailableShiftSections = void 0;
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const maybe_1 = require("@app/util/functional/maybe");
const use_plugin_1 = require("@app/util/hooks/use-plugin");
const useActivatePlugin_1 = require("@app/util/hooks/useActivatePlugin");
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
const react_1 = __importDefault(require("react"));
const shift_context_1 = require("./shift-context");
const shift_attributes_1 = require("@app/util/shift-attributes");
const useAvailableShiftSections = () => {
    const workspace = (0, useWorkspace_1.useWorkspace)();
    const { isPluginEnabled } = (0, use_plugin_1.usePlugin)();
    const { formType, initialData, transferStatus, transferRole } = (0, shift_context_1.useShift)();
    const isEnabledEmergency = isPluginEnabled('standby', false);
    const { activatePluginFn: activateEmergency } = (0, useActivatePlugin_1.useActivatePlugin)('standby');
    const isEnabledDayswapsPro = isPluginEnabled('dayswapspro', false);
    const { activatePluginFn: activateDayswapsPro } = (0, useActivatePlugin_1.useActivatePlugin)('dayswapspro');
    const staticSections = react_1.default.useMemo(() => [
        {
            name: (0, util_1.t)('AUTOMATIC_PAUSE'),
            id: 'automatic-pause',
        },
        {
            name: (0, util_1.t)('MANUAL_PAUSE'),
            id: 'manual-pause',
            visible: false,
        },
        {
            name: (0, util_1.t)('OVERTIME'),
            id: 'overtime',
        },
        {
            name: (0, util_1.t)('EDIT_SHIFT_AGENDA_TITLE'),
            id: 'agenda',
        },
        {
            name: (0, util_1.t)('SHIFT_FLAG.standBy'),
            id: 'emergency',
            isBlocked: !isEnabledEmergency,
            onBlockedContent: activateEmergency,
        },
        {
            name: (0, util_1.t)('NOTE'),
            id: 'note',
        },
        {
            name: (0, util_1.t)('SKILL'),
            id: 'experience',
        },
        {
            name: (0, util_1.t)('LOCALITY'),
            id: 'localities',
            visible: transferStatus === 'none',
        },
        {
            name: (0, util_1.t)('MA_TRANSFER'),
            id: 'transfer',
            visible: formType === 'live' && !initialData?.isOffersOrUnassigned,
            isBlocked: !isEnabledDayswapsPro ||
                transferStatus === 'pending' ||
                transferStatus === 'accepted',
            onBlockedContent: activateDayswapsPro,
        },
    ], 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isEnabledEmergency, isEnabledDayswapsPro, formType, transferStatus]);
    const customAttributes = react_1.default.useMemo(() => {
        if (transferRole === 'master')
            return [];
        return new maybe_1.Maybe(workspace?.shiftAttributes)
            .map((sa) => sa.filter(util_1.isValue))
            .map((_customAttributes) => _customAttributes.map((ca) => {
            return {
                name: (0, shift_attributes_1.formatAttributeName)({ attribute: ca }),
                id: ca?.id ?? '-',
                isCustomAttribute: true,
                attribute: (0, maybe_unwrap_1.unwrapMaybe)(ca),
            };
        }))
            .get(() => []);
    }, [workspace?.shiftAttributes, transferRole]);
    return staticSections.concat(customAttributes);
};
exports.useAvailableShiftSections = useAvailableShiftSections;
